import { useAppSelector } from 'app/hooks';
import axios from 'axios';
import Button from 'blocks/Button';
import Input from 'blocks/Input';
import Breadcrumb from 'components/Breadcrumb';
import TermsCondition from 'components/TermsCondition';
import ConvertMilageModal from 'components/modals/ConvertMilesModal';
import Paths from 'helper/paths';
import { buyMilageTerms } from 'helper/static-constant';
import { useForm } from 'hooks/useForm';
import WithSidebar from 'layouts/WithSidebar';
import BreadcrumbInterface from 'models/breadcrumb/breadcrumb.interface';
import { useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { toast } from 'react-toastify';
import { UserTierState } from 'store/tiers/tiersSlice';
import urls from 'utils/urls';
import * as S from './convert.styles';

const ConvertMilage = () => {
  const { t } = useTranslation();
  const convertMilageModalRef = useRef<any>();
  const [tier, setTier] = useState<any>();
  const userTiers = useAppSelector(UserTierState);
  const breadcrumbLinks = [
    {
      title: t(`pageTitles.${Paths.Dashboard.index().name}`),
      url: Paths.Dashboard.index().route,
      active: true,
    },
    {
      title: t(`pageTitles.${Paths.Services.convertMilages().name}`),
      url: '',
      active: false,
    },
  ] as BreadcrumbInterface[];

  const { inputFields, handleChange } = useForm({
    miles: {
      name: 'miles',
      value: '',
      type: 'number',
      placeholder: t('pages.services.convertMilage.sections.form.sections.milesToConvert.fields.amount.placeholder'),
      label: t('pages.services.convertMilage.sections.form.sections.milesToConvert.fields.amount.label'),
    },
  });

  const convertMilageModal = async () => {
    let data = {
      mile: inputFields.miles.value,
    };
    if (data.mile > (userTiers?.rewardMilage || 0))
      return toast.error(t('pages.services.convertMilage.sections.form.sections.milesToConvert.error'));

    axios
      .post(urls.calculateMile, data)
      .then((res) => {
        convertMilageModalRef.current.openModal();
        setTier(res.data.response.tierMilage);

        if (!res) return;
      })
      .catch((ex) => {
        toast.error(ex?.response?.data?.message);
      });
  };

  return (
    <WithSidebar>
      <S.ConvertMilage>
        <Breadcrumb links={breadcrumbLinks} title={t('pages.services.convertMilage.title')} />

        <S.ConvertMilageBox>
          <S.ConvertMilageBoxLeft>
            <S.ConvertMilageBoxLeftCard>
              <S.ConvertMilageBoxLeftText>
                {t('pages.services.convertMilage.sections.form.sections.milesToConvert.title')}
              </S.ConvertMilageBoxLeftText>
              <S.ConvertMilageBoxLeftDes>
                {t('pages.services.convertMilage.sections.form.sections.milesToConvert.des')}
              </S.ConvertMilageBoxLeftDes>
              <Input inputField={inputFields.miles} onChange={handleChange} dir={'ltr'} />
              <Button
                styleType="default"
                className="transfer-button mx-auto fs-xs mt-auto"
                onClick={() => convertMilageModal()}
              >
                {t('pages.services.convertMilage.sections.form.submitCTA')}
              </Button>
            </S.ConvertMilageBoxLeftCard>
          </S.ConvertMilageBoxLeft>

          <S.ConvertMilageBoxRight>
            <TermsCondition title={t('pages.services.convertMilage.sections.terms.title')} termsItem={buyMilageTerms} />
          </S.ConvertMilageBoxRight>
        </S.ConvertMilageBox>
      </S.ConvertMilage>

      <ConvertMilageModal ref={convertMilageModalRef} miles={inputFields.miles.value} tierMilage={tier} />
    </WithSidebar>
  );
};

export default ConvertMilage;
